var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAntimatterLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 373 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-208.452,-240.161)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-23.9511,37.716)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(72,0,0,72,230.61,257.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.624,0L0.743,0L0.446,-0.75L0.322,-0.75L0.025,0L0.145,0L0.207,-0.162L0.562,-0.162L0.624,0ZM0.246,-0.264L0.384,-0.627L0.523,-0.264L0.246,-0.264Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(72,0,0,72,283.786,257.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.346,-0.527C0.277,-0.527 0.224,-0.496 0.19,-0.443L0.19,-0.517L0.082,-0.517L0.082,0L0.19,0L0.19,-0.295C0.191,-0.387 0.244,-0.433 0.314,-0.433C0.381,-0.433 0.43,-0.399 0.43,-0.299L0.43,0L0.539,0L0.539,-0.314C0.539,-0.456 0.458,-0.527 0.346,-0.527Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(72,0,0,72,325.396,257.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.337,-0.434L0.337,-0.517L0.21,-0.517L0.21,-0.66L0.101,-0.66L0.101,-0.517L0.017,-0.517L0.017,-0.434L0.101,-0.434L0.101,-0.151C0.101,-0.053 0.164,0 0.258,0L0.336,0L0.336,-0.087L0.28,-0.087C0.239,-0.087 0.21,-0.114 0.21,-0.164L0.21,-0.434L0.337,-0.434Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(72,0,0,72,350.236,257.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.137,-0.625C0.173,-0.625 0.205,-0.655 0.205,-0.692C0.205,-0.73 0.173,-0.76 0.137,-0.76C0.1,-0.76 0.068,-0.73 0.068,-0.692C0.068,-0.655 0.1,-0.625 0.137,-0.625ZM0.082,0L0.19,0L0.19,-0.517L0.082,-0.517L0.082,0Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(72,0,0,72,367.622,257.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.633,-0.527C0.567,-0.527 0.514,-0.496 0.48,-0.445C0.454,-0.502 0.4,-0.527 0.337,-0.527C0.271,-0.527 0.221,-0.496 0.19,-0.445L0.19,-0.517L0.082,-0.517L0.082,0L0.19,0L0.19,-0.315C0.19,-0.391 0.231,-0.431 0.293,-0.431C0.347,-0.431 0.391,-0.4 0.391,-0.319L0.391,0L0.5,0L0.5,-0.315C0.5,-0.391 0.541,-0.431 0.603,-0.431C0.656,-0.431 0.7,-0.4 0.7,-0.319L0.7,0L0.809,0L0.809,-0.354C0.809,-0.458 0.737,-0.527 0.633,-0.527Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(72,0,0,72,428.814,257.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.294,0.01C0.376,0.01 0.439,-0.023 0.48,-0.075L0.48,0L0.589,0L0.589,-0.517L0.481,-0.517L0.481,-0.442C0.439,-0.494 0.376,-0.527 0.294,-0.527C0.156,-0.527 0.039,-0.411 0.039,-0.259C0.039,-0.107 0.156,0.01 0.294,0.01ZM0.318,-0.087C0.223,-0.087 0.147,-0.161 0.147,-0.259C0.147,-0.357 0.223,-0.431 0.318,-0.431C0.413,-0.431 0.488,-0.357 0.488,-0.259C0.488,-0.161 0.413,-0.087 0.318,-0.087Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(72,0,0,72,474.959,257.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.337,-0.434L0.337,-0.517L0.21,-0.517L0.21,-0.66L0.101,-0.66L0.101,-0.517L0.017,-0.517L0.017,-0.434L0.101,-0.434L0.101,-0.151C0.101,-0.053 0.164,0 0.258,0L0.336,0L0.336,-0.087L0.28,-0.087C0.239,-0.087 0.21,-0.114 0.21,-0.164L0.21,-0.434L0.337,-0.434Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(72,0,0,72,499.799,257.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.337,-0.434L0.337,-0.517L0.21,-0.517L0.21,-0.66L0.101,-0.66L0.101,-0.517L0.017,-0.517L0.017,-0.434L0.101,-0.434L0.101,-0.151C0.101,-0.053 0.164,0 0.258,0L0.336,0L0.336,-0.087L0.28,-0.087C0.239,-0.087 0.21,-0.114 0.21,-0.164L0.21,-0.434L0.337,-0.434Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(72,0,0,72,524.076,257.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.577,-0.265C0.573,-0.418 0.458,-0.527 0.31,-0.527C0.155,-0.527 0.038,-0.408 0.038,-0.259C0.038,-0.109 0.153,0.01 0.312,0.01C0.416,0.01 0.501,-0.041 0.546,-0.124L0.458,-0.161C0.426,-0.11 0.372,-0.081 0.312,-0.081C0.222,-0.081 0.147,-0.147 0.143,-0.243L0.576,-0.243L0.577,-0.265ZM0.31,-0.441C0.388,-0.441 0.449,-0.393 0.465,-0.317L0.149,-0.317C0.169,-0.392 0.231,-0.441 0.31,-0.441Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(72,0,0,72,565.756,257.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.188,-0.425L0.188,-0.517L0.082,-0.517L0.082,0L0.19,0L0.19,-0.265C0.19,-0.379 0.261,-0.418 0.367,-0.418L0.367,-0.522C0.28,-0.52 0.218,-0.477 0.188,-0.425Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(72,0,0,72,591.088,257.148)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.091,
    y: -0.1,
    width: 0.1,
    height: 0.1,
    style: {
      fill: "rgb(255,0,0)",
      fillRule: "nonzero"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntimatterLogoWhite);
export default __webpack_public_path__ + "static/media/antimatter-logo-white.d90c5e32fe16909165feb73abb6c326d.svg";
export { ForwardRef as ReactComponent };